<table mat-table [dataSource]="participants">
    <!-- Identification Column -->
    <ng-container matColumnDef="identification">
        <th mat-header-cell *matHeaderCellDef> RUT </th>
        <td mat-cell *matCellDef="let participant"> {{participant.identification | rut}} </td>
     </ng-container>

    <!-- Name Column -->
     <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Nombre </th>
        <td mat-cell *matCellDef="let participant"> {{participant.name}} </td>
     </ng-container>

     <!-- Email Column -->
     <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef> Correo </th>
        <td mat-cell *matCellDef="let participant"> {{participant.email}} </td>
     </ng-container>

     <ng-container matColumnDef="status">
      >
        <th mat-header-cell *matHeaderCellDef> Estado </th>
        <td mat-cell *matCellDef="let participant"> 
            <signature-participant-status-badge [status]="participant.status"></signature-participant-status-badge>
        </td>
     </ng-container>

     <tr mat-header-row *matHeaderRowDef="['identification', 'name', 'email', 'status']"></tr>
     <tr mat-row *matRowDef="let row; columns: ['identification', 'name', 'email', 'status' ];"></tr>
</table>